import { questions, questions_en, questions_sc } from "../Config/data";
import { GAME_DURATION } from "../Config/data";
import { dispatchUpdateScore } from "../reducers/sceneReducer";
export default class GameViewModel {
  Scene3;

  get latestScore() {
    return this._latestScore;
  }
  set latestScore(value) {
    this._latestScore = value;
    dispatchUpdateScore(value);
  }

  latestScore = 0;
  timeRemaining;
  gameTotalTime;
  language;

  constructor() {
    this.gameTotalTime = GAME_DURATION;
    this.questions = questions;
    this.questions_en = questions_en;
    this.questions_sc = questions_sc;
    this.language = null;
  }
}
